import React from 'react';

type SurveyQuestionThumbnailSize = 'small' | 'medium' | 'large';

type SurveyQuestionThumbnailProps = {
    src: string;
    alt: string;
    size: SurveyQuestionThumbnailSize;
};

const SurveyQuestionThumbnail: React.FC<SurveyQuestionThumbnailProps> = ({
    src,
    alt,
    size,
}) => {
    const sizesMap: Record<SurveyQuestionThumbnailSize, number> = {
        small: 50,
        medium: 65,
        large: 80,
    };
    return (
        <img
            style={{ borderRadius: '10px' }}
            height={sizesMap[size]}
            width={sizesMap[size]}
            src={src}
            alt={alt}
        />
    );
};

export default SurveyQuestionThumbnail;